(function() {

  const wrapper = document.querySelector('[data-bundle-quick-add-outer]');
  const addToCartBtns = wrapper.querySelectorAll('[data-bundle-quick-add-to-cart]');
  const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');

  var selected = [];

  init();

  function init() {
    addToCartBtns.forEach((button) => {
      button.addEventListener('click', handleAddToCart);
    })
  }

  function handleAddToCart(e) {
    var bundleId = e.target.dataset.bundleParentId;
    if (!bundleId) return;

    const bundleJson = JSON.parse(document.querySelector(`[data-bundle-product-items-json="${bundleId}"]`).innerHTML);
    const setEl = wrapper.querySelector('[data-bundle-parent]');
    const setTitle = setEl.getAttribute('data-bundle-parent-title');
    const setHandle = setEl.getAttribute('data-bundle-parent-handle');
    const setDiscount = setEl.getAttribute('data-bundle-parent-discount');
    const setCommissionable = setEl.getAttribute('data-bundle-parent-commissionable');
    const setIsKit = setEl.getAttribute('data-bundle-parent-is-kit');

    var multiplier = 1;

    selected = bundleJson.map(function(item) {
      return {
        id: item.current_variant_id,
        quantity: item.bundle_quantity * multiplier,
        properties: {
          _set: setTitle,
          _set_handle: setHandle,
          _set_discount: setDiscount,
          _set_type: "Fixed",
          _set_commissionable: setCommissionable,
          _set_is_kit: setIsKit !== null
        }
      }
    });
    
    addToCartAction(selected, e.target);
  }

  
  /*------- Helpers -------*/

  function addToCartAction(selected, btn) {
    
    const formData = {
      'items': selected
    }

    if (selected.length) {
      btn.disabled = true;
      btn.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then((res) => {
        console.log('res: ', res);
        if (!res.ok) throw new Error("Unable to add to cart");
        return res.json();
      })
      .then((data) => {
        reloadCart();
        btn.classList.remove('loading');
        btn.classList.add('has-success');

        setTimeout(() => {
          btn.classList.remove('has-success');
          btn.disabled = false;
          openDrawer();
        }, 1500);
      })
      .catch((err) => {
        btn.classList.remove('loading');
        console.error(err);
      })
    }
  }

  function reloadCart() {
    document.dispatchEvent(
      new CustomEvent('theme:cart:init', {
        bubbles: true
      })
    );
    document.dispatchEvent(
      new CustomEvent("theme:cart:reload", {
        bubbles: true,
      })
    );
  }

  function openDrawer() {
    cartDrawer.dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: true,
      })
    );
  }

})();